import { render, staticRenderFns } from "./ContactInfoCard.vue?vue&type=template&id=2a2e46bc&"
import script from "./ContactInfoCard.vue?vue&type=script&lang=ts&"
export * from "./ContactInfoCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports